var map = {
	"./3.jpg": 662561,
	"./3_de.jpg": 20493,
	"./3_es.jpg": 996254,
	"./3_fr.jpg": 386286,
	"./3_it.jpg": 190301,
	"./3_jp.jpg": 100641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813097;